import { defineTranslations } from '@/core/i18n';

const translations = defineTranslations({
    defaultLocale: "en",
    locales: {
        "en": {"TITLE":["Add company"],"PLACEHOLDER":["Search by name or KVK number"],"RESULTS":["Companies"],"HINT":["Type a company name or KVK number"],"SEARCHING":["Searching…"],"NO_RESULTS":["No companies found"],"KVK_NUMBER":["KVK ",{"t":"arg","n":"number"}],"COMPANY_ADDED":[{"t":"arg","n":"name"}," added"],"ADD_ERROR":["The company could not be added"]},
        "nl": {"TITLE":["Bedrijf toevoegen"],"PLACEHOLDER":["Zoek op naam of KVK-nummer"],"RESULTS":["Bedrijven"],"HINT":["Typ een bedrijfsnaam of KVK-nummer"],"SEARCHING":["Zoeken…"],"NO_RESULTS":["Geen bedrijven gevonden"],"KVK_NUMBER":["KVK ",{"t":"arg","n":"number"}],"COMPANY_ADDED":[{"t":"arg","n":"name"}," toegevoegd"],"ADD_ERROR":["Het bedrijf kon niet worden toegevoegd"]},
    },
}, import.meta.hot?.data?.translations);

if (import.meta.hot?.data) {
    import.meta.hot.data.translations = translations;
    import.meta.hot.accept();
}

export default translations;
